import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Loguea cada cambio de ruta:
 *  - Consola en desarrollo
 *  - GTM dataLayer (event: page_view) en producción
 *  - Marca inicio/fin para medir "time to interactive" de Suspense lento
 *
 * Uso: colócalo una vez dentro de <BrowserRouter> (ej. en AppRouter).
 */
export const useNavigationLogger = () => {
    const location = useLocation();
    const navigationStartRef = useRef(Date.now());
    const previousPathRef = useRef(null);

    useEffect(() => {
        const currentPath = location.pathname + location.search;
        const previousPath = previousPathRef.current;

        // Cálculo de tiempo desde el último cambio (aprox navegación previa)
        const now = Date.now();
        const elapsed = now - navigationStartRef.current;

        // // Log en dev
        // if (process.env.NODE_ENV !== "production") {
        //     const timing = previousPath ? ` (prev: ${elapsed}ms)` : "";
        //     // eslint-disable-next-line no-console
        //     console.info(`[Nav] ${previousPath || "(start)"} → ${currentPath}${timing}`);

        //     // Ruta lenta (más de 2s cargando) → warning
        //     if (previousPath && elapsed > 2000) {
        //         // eslint-disable-next-line no-console
        //         console.warn(`[Nav] Ruta lenta detectada: ${previousPath} → ${currentPath} tardó ${elapsed}ms`);
        //     }
        // }

        // Track GTM / Analytics
        if (typeof window !== "undefined" && Array.isArray(window.dataLayer)) {
            window.dataLayer.push({
                event: "page_view",
                page_path: currentPath,
                page_title: document.title,
                page_location: window.location.href,
                previous_path: previousPath || "(direct)",
                navigation_ms: elapsed,
            });
        }

        // Reset timing para la próxima navegación
        navigationStartRef.current = now;
        previousPathRef.current = currentPath;
    }, [location.pathname, location.search]);
};

/**
 * Componente wrapper para usar el logger de forma declarativa.
 *   <NavigationLogger />
 */
export const NavigationLogger = () => {
    useNavigationLogger();
    return null;
};
